module.exports = __webpack_public_path__ + "img/knmi-air-pollution.231e588d.jpg";